import script from "./CatalogoBloquesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogoBloquesModal.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogoBloquesModal.vue?vue&type=style&index=0&id=11ab8470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11ab8470"]])

export default __exports__